<template>
  <div id="main" style="padding-top: 1px;">
    <!-- bottom banner -->
    <div class="container">
      <div class="flex justify-around items-center mt3 fields_left col-parent-padding">
        <span class="caps italic col-10 sm-col-6 h2 black italic subtitle-mobile" v-html="$store.state.translations.dediee_aux_secteurs"></span>
        <div class="col col-6 mobile_hide">
          <div class="row items-end">
            <span class="big_number bold" v-observe-visibility="{callback: visible => visible && startAnim(anims.years), once: true}">{{anims.years.value}}</span>
            <span class="subtitle_banner caps bold italic" v-html="$store.state.translations.annees_dexperience"></span>
          </div>
        </div>
      </div>
      <div class="flex items-end justify-around pt3 col-parent-padding">
        <div class="col-12 sm-col-6" style="overflow-anchor: none;">
          <div class="foot_title line_bottom caps line_bottom_left">
            <!--<span :class="{hidden: isWordHidden}">{{words[currentWordIndex]}}</span>-->
            <span v-for="(word, i) in words" :key="i">{{word}}</span>
          </div>
        </div>
        <div class="col-6 mobile_hide">
          <div class="foot_title line_bottom caps mobile_hide">{{$store.state.translations.objectif}}</div>
        </div>
      </div>
      <div class="flex items-baseline justify-around mt4 home_fields fields_left">
        <div class="col col-6">
          <a href="#" @click.prevent="goToElement('#bottom_logo')"><span class="subtitle">{{$store.state.translations.ils_nous_font_confiance}}</span></a>
        </div>
        <div class="col col-6 mobile_hide">
          <router-link :to="{name: 'expertise'}"><span class="subtitle">{{$store.state.translations.notre_expertise_pour_votre_besoin}}</span></router-link>
        </div>
      </div>
    </div>
    <!-- Section white banner -->
    <clients/>
    <!-- Section black banner -->
    <div class="flex justify-around center my3 flex-wrap container">
      <div class="column md-col-3 col-6">
        <span class="number_red black italic" v-observe-visibility="{callback: visible => visible && startAnim(anims.number1), once: true}">{{anims.number1.value}}</span>
        <span>{{$store.state.translations.projets_menes_a_bien}}</span>
      </div>
      <div class="column md-col-3 col-6">
        <span class="number_red black italic" v-observe-visibility="{callback: visible => visible && startAnim(anims.number2), once: true}">{{anims.number2.value}}</span>
        <span>{{$store.state.translations.piranhas_surentraines}}</span>
      </div>
      <div class="column md-col-3 col-6">
        <span class="number_red black italic mobile_spacing" v-observe-visibility="{callback: visible => visible && startAnim(anims.number3), once: true}">{{anims.number3.value}}</span>
        <span>{{$store.state.translations.tasses_de_cafe}}</span>
      </div>
      <div class="column md-col-3 col-6">
        <span class="number_red black italic mobile_spacing" v-observe-visibility="{callback: visible => visible && startAnim(anims.number4), once: true}">{{anims.number4.value}}</span>
        <span>{{$store.state.translations.entrecotes_devorees}}</span>
      </div>
    </div>
    <!-- Section banner brands -->
    <brands/>
  </div>
</template>

<script>
import Brands from "../components/brands";
import clients from "../components/clients";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  data () {
    return {
      // currentWordIndex: 0,
      // isWordHidden: false,
      anims: {
        years: {
          value: 0,
          end: 10
        },
        number1: {
          value: 0,
          end: 232
        },
        number2: {
          value: 0,
          end: 8
        },
        number3: {
          value: 0,
          end: 23
        },
        number4: {
          value: 0,
          end: 29
        }
      }
    }
  },
  computed: {
    words () {
			return this.$store.state.translations.secteurs ? this.$store.state.translations.secteurs.split('\n') : [];
    }
  },
  methods: {
    async startAnim (anim) {
      for (let i = 1; i <= anim.end; i++) {
        anim.value = i;
        await sleep(1200 / anim.end);
      }
    },
    goToElement (el) {
      document.querySelector(el).scrollIntoView({behavior: "smooth"});
    }
  },
  mounted () {
    // setInterval(async () => {
    //   this.isWordHidden = true;
    //   await sleep(1000);
    //   this.currentWordIndex = this.currentWordIndex === this.words.length - 1 ? 0 : this.currentWordIndex + 1;
    //   this.isWordHidden = false;
    // }, 3000);
  },
  components: {clients, Brands},
};
</script>